/* eslint-disable no-nested-ternary */
import { Button, Chip, Grid, IconButton } from '@material-ui/core';
import { InsertInvitation, Send, Visibility } from '@material-ui/icons';
import {
  getDocumentsByOrganism,
  getInfoStudentDocument,
  getInfosBusiness,
  getInfosIndividual,
  getInfosSchool,
} from '@webapps/business';
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useMutation,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';
import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const Documents = ({ UserId, OrganismId }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const [page, setPage] = useState(1);

  const {
    // status: load,
    data: { content: documents = [], totalElements } = {},
    // refetch: refetchDocuments,
    // isFetching,
  } = useQuery(getDocumentsByOrganism, {
    key: ['documentsStudent', page + UserId + OrganismId],
    variables: {
      idOrganism: OrganismId,
      idStudent: UserId,
      page: page - 1,
      size: 10,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewAchievement, setViewAchievement] = useState(false);
  const [path, setPath] = useState('');

  const handleOpenViewAchievement = () => {
    setViewAchievement(true);
  };
  const handleCloseViewAchievement = () => {
    setViewAchievement(false);
  };

  const {
    data: dataAttachment,
    // isLoading: isLoadingInfoAttachment,
    isSuccess: isSuccessInfoAttachment,
    mutateAsync: mutateInfoAttachment,
  } = useMutation(getInfoStudentDocument);

  const getPathLink = (id) => {
    mutateInfoAttachment({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessInfoAttachment) {
      setPath('');
      getFileURLPDF(dataAttachment?.path, setPath);
      handleOpenViewAchievement();
    }
  }, [isSuccessInfoAttachment]);

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <div>
          {!documents?.length ? (
            <div
              className={css({
                textAlign: 'center',
                color: '#5D75A8',
              })}
            >
              <FormattedMessage id="noElements" />
            </div>
          ) : (
            <Grid container style={{ backgroundColor: '#F3F7FF', borderRadius: 20, padding: 10 }}>
              {documents.map(
                (
                  { direction, id, name, createdAt },
                  index
                ) => (
                  <Grid item xs={12} md={6} >
                    <div style={{ padding: 10 }}>
                      <div style={{ padding: 20, borderRadius: 10, backgroundColor: '#FFF' }} key={index}>
                        <div className={global.infoText}>{name}</div>

                        {/* A décommenter quadn back enverra l'info 
                        {direction === 'ORGANIZATION-STUDENT' && (
                          <Chip
                            className={css({ margin: spacing(0.5) })}
                            label="Envoyé"
                            size="small"
                          />
                        )}
                        {direction === 'STUDENT-ORGANIZATION' && (
                          <Chip
                            className={css({ margin: spacing(0.5) })}
                            label="Réceptionné"
                            size="small"
                          />
                        )} */}

                        {!direction && (
                          <div className={cx(global.infoText, classes.address)}>
                            <Send className={global.infoIcon} />
                            <div>Réceptionné</div>
                          </div>
                        )}

                        <div className={cx(global.infoText, classes.address)}>
                          <InsertInvitation className={global.infoIcon} />
                          <div>
                            <FormattedDate
                              day="numeric"
                              month="long"
                              value={new Date(createdAt)}
                              year="numeric"
                            />
                          </div>
                        </div>
                        <Button variant='outlined' className={classes.btn} fullWidth onClick={() => getPathLink(id)}>
                          Voir le document
                        </Button>
                      </div>
                    </div>
                  </Grid>
                ))}
            </Grid>
          )}
        </div>
        <Pagination
          onChange={handlePaginationChange}
          page={page}
          pageCount={10}
          totalCount={totalElements}
        />
      </div>
      <ModalFullScreenWithoutAction
        onCancel={handleCloseViewAchievement}
        open={viewAchievement}
        title="Mes documents"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const FromUser = ({ id, type }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();
  const { data: info = {} } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
    enabled: type === 'STUDENT',
  });

  const { data: infosSchool = {} } = useQuery(getInfosSchool, {
    key: 'schoolInfos',
    variables: { id },
    enabled: type === 'SCHOOL',
  });

  const { data: infosBusiness = {} } = useQuery(getInfosBusiness, {
    key: 'businessInfos',
    variables: { id },
    enabled: type === 'BUSINESS',
  });

  return id && type ? (
    <TableCell align="center">
      {type === 'STUDENT'
        ? info?.fullName
        : type === 'SCHOOL'
          ? infosSchool?.name
          : infosBusiness?.name}
    </TableCell>
  ) : (
    <TableCell align="center">
      <Chip
        className={css({ margin: spacing(0.5) })}
        label="Non renseigné"
        size="small"
      />
    </TableCell>
  );
};

FromUser.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  btn: {
    marginTop: spacing(2.5)
  },
  paper: {
    background: 'white',
  },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'black',
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: spacing(2),
  },
  address: {
    marginTop: spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
});

Documents.propTypes = {
  UserId: PropTypes.string,
};

export default Documents;
